import chris from "../../../images/chris.png";
import Nil from "../../../images/Nil.png";
import Miracle from "../../../images/Miracle.png";
import ijeoma from "../../../images/ijeoma.png";

export const internshipSchedule = [
  {
    header: "Wk 1 - Welcome & Setup",
    body: "Get onboarded, access the private community, and explore your tools. Setup Agencer.",
  },
  {
    header: "Wk 2 - Create a Winning Profile",
    body: "Build a profile that attracts clients. Get expert feedback.",
  },
  {
    header: "Wk 3 - Build a Credible Portfolio",
    body: "Launch a project or blog post that shows off your skills.",
  },
  {
    header: "Wk 4 - Learn How to Bid Like a Pro (Part 1)",
    body: "Submit 4 proposals using Agencer. Learn what works.",
  },
  {
    header: "Wk 5 - Learn How to Bid Like a Pro (Part 2)",
    body: "Submit more proposals using Agencer. Learn what works.",
  },
  {
    header: "Wk 6 - Master Client Communication & Delivery",
    body: "Learn how to work with clients and deliver top-notch work.",
  },
];

export const mentorshipSupport = [
  {
    header: "Weekly Live Sessions",
    body: "Learn directly from top freelancers who are active in the industry",
  },
  {
    header: "1-on-1 Mentorship",
    body: "Get personalized guidance tailored to your skill set and goals",
  },
  {
    header: "Expert Feedback",
    body: "Receive personalized feedback on your profile, proposals, and projects",
  },
  {
    header: "Private Community",
    body: "Join a private Discord channel for ongoing support and community",
  },
];

export const benefits = [
  {
    header: "Professional Upwork/LinkedIn Profile",
    body: "Attract clients with a profile that stands out",
  },
  {
    header: "Freelancer-Ready Portfolio",
    body: "Showcase your best work with confidence",
  },
  {
    header: "Real Proposals Sent",
    body: "At least five professional bids in the market.",
  },
  {
    header: "Your First Freelance Gig",
    body: "Our primary goal is to help you land it",
  },
  {
    header: "Lifetime Community Access",
    body: "Keep learning and networking after the sprint.",
  },
  {
    header: "6‑Month Agencer Access",
    body: "Continue prospecting on autopilot.",
  },
];

export const faqs = [
  {
    id: "faq1",
    question: "Is the internship really free?",
    answer:
      "Yes. Your only investment is your time and an in‑demand skill—development, design, writing, marketing, or another service you can offer.",
  },
  {
    id: "faq2",
    question: "Will I receive a certificate?",
    answer:
      "Yes—provided you attend every live session and finish all assignments. Certificates are issued at the organizers’ discretion.",
  },
  {
    id: "faq3",
    question: "What do I need before I start?",
    answer:
      "A marketable skill you want to sell. A LinkedIn or Upwork account (or willingness to set one up in Week 1).",
  },
  {
    id: "faq4",
    question: "What if I don’t land a client in six weeks?",
    answer:
      "We target an 80 % success rate, but outcomes depend on your effort. Even if you don’t close a deal during the program, you’ll graduate with an optimized profile, polished proposals, and the Agencer to keep pitching until you succeed.",
  },
  {
    id: "faq5",
    question: "Do I have to use Upwork?",
    answer:
      "No. The Agencer can mine leads on both Upwork and LinkedIn. If you opt for Upwork, you’ll need to purchase your own Connects (proposal credits).",
  },
];

export const mentorsInfo = [
  {
    name: "Chris Branham",
    role: "Founder, Desktop Creatives",
    image: chris,
  },
  {
    name: "Ijeoma Onwuka (Upwork Queen)",
    role: "Events & Community Manager, Bitter Brains",
    image: ijeoma,
  },
  {
    name: "Nilanjan Raychaudhuri",
    role: "Founder, Tublian",
    image: Nil,
  },
  {
    name: "Miracle Mark",
    role: "Founder, Milmark Institute",
    image: Miracle,
  },
];
